



















































































import {Vue, Component} from 'vue-property-decorator';
import APIKeyList from '@/components/APIKeyList.vue';
import GenericButton from '@/components/GenericButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import Dialog from '@/components/Dialog.vue';
import Table from '@/components/Table.vue';
import ActionBarButton from '@/components/ActionBarButton.vue';
import { copyToClipboard } from '@/classes/utils';
import {Getter} from 'vuex-class';

@Component({
  components: {ActionBarButton, Table, Dialog, CancelButton, ConfirmButton, GenericButton, APIKeyList},
})
export default class AccountAPIKeys extends Vue {
  @Getter private activeAccountId!: any;
  @Getter private hasPermission: any;
  private copyToClipboard: (text: string) => boolean = copyToClipboard;

  private showDisposeDialog: boolean = false;
  private loading: boolean = false;
  private showDisposeAction: boolean = false;
  private selectedRows: any[] = [];
  private showApiKeyDialog: boolean = false;

  private tableData = {
    headers: [
      {
        text: 'Name',
        value: 'name',
        align: 'start',
        filterable: true,
      },
      {
        text: 'Key Id',
        value: 'key_id',
        align: 'start',
        filterable: true,
      },
      {
        text: '',
        value: 'api_token',
      },
    ],
    total: 0,
    filters: {},
    distinctRows: {},
    rows: [
      {
        id: 236,
        name: 'legionella-app',
        key_id: 'yijXX8r-i2sitFg6zX-jxotRrcJl2coEFCMivdhDt2A',
        api_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjIzNiwidXNlckVtYWlsIjoiYXBpLXVzZXItMTY0NDg1OTY2OTQyMCIsImlhdCI6MTY0NDg1OTY2OX0.yijXX8r-i2sitFg6zX-jxotRrcJl2coEFCMivdhDt2A',
        roles: [],
        sortedRoles: [],
        roleIds: [],
      },
      {
        id: 255,
        name: 'NewAPIKey',
        key_id: 'CKv2q7OcyXl34F_oKiGg7Gp51Do91RDI3VvOlDH2Rw0',
        api_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjI1NSwidXNlckVtYWlsIjoiYXBpLXVzZXItMTY1MTA2MjU3MzYzMyIsImlhdCI6MTY1MTA2MjU3M30.CKv2q7OcyXl34F_oKiGg7Gp51Do91RDI3VvOlDH2Rw0',
        roles: [
          'Organisation Admin',
        ],
        sortedRoles: [
          {
            name: 'Organisation Admin',
            id: 1,
          },
        ],
        roleIds: [
          1,
        ],
      },
    ],
  };


  private async disposeKeys() {
    this.loading = true;
    try {
      await Promise.all(
          this.selectedRows.map(
              async (user: any): Promise<any> => {
                // await UserService.removeUser(user.id);
              },
          ),
      );

      this.showDisposeAction = false;
      this.showDisposeDialog = false;
      this.selectedRows = [];
    } finally {
      this.loading = false;
    }

    // await this.getApiUsers();
  }

}
